import { PublicApiSettingsFactory } from './publicApiSettingsFactory';

import type {
  PublicApiSettingsEntity,
  PublicApiSettingsJson,
  PublicApiSettingsProps,
} from './publicApiSettingsEntity';
import type { PublicApiSettingsIRepository } from './publicApiSettingsIRepository';
import type { EntityDataType } from '@/infra/appsync';

import { AppsyncRepositoryPvt } from '@/domain/appsyncRepositoryPvt';
import {
  EntityName,
} from '@/infra/appsync';

/**
 * PublicApiSettingsRepository
 */
export class PublicApiSettingsRepository extends AppsyncRepositoryPvt<
  PublicApiSettingsEntity,
  PublicApiSettingsProps,
  PublicApiSettingsJson
> implements PublicApiSettingsIRepository {
  private factory: PublicApiSettingsFactory = new PublicApiSettingsFactory();

  protected get entityName(): EntityName {
    return EntityName.WagakoNurseryPaymentPublicApiSettingsEntity;
  }

  protected createFromEntityDataType = (
    props: EntityDataType,
  ) => this.factory.createFromEntityDataType(props);
}
